import React from "react";

const ProgressBar = ({ status }) => {
  const statusMap = {
    "Đã tiếp nhận": {
      step: 1,
      percent: 25,
      bgColor: "bg-status-info",
      textColor: "text-blue-600",
    },
    "Đang xử lý": {
      step: 2,
      percent: 50,
      bgColor: "bg-secondary-main",
      textColor: "text-orange-500",
    },
    "Chờ nộp phí": {
      step: 3,
      percent: 75,
      bgColor: "bg-status-warning",
      textColor: "text-orange-500",
    },
    "Hoàn thành": {
      step: 4,
      percent: 100,
      bgColor: "bg-status-success",
      textColor: "text-green-600",
    },
    "Đã trả kết quả": {
      step: 4,
      percent: 100,
      bgColor: "bg-status-success",
      textColor: "text-green-600",
    },
    "Kết thúc xử lý": {
      step: 4,
      percent: 100,
      bgColor: "bg-red-600",
      textColor: "text-red-600",
    },
  };

  const currentStatus = statusMap[status] || {
    step: 2,
    percent: 50,
    bgColor: "bg-secondary-main",
    textColor: "text-orange-500",
  };

  const steps = [
    { id: 1, name: "Tiếp nhận" },
    { id: 2, name: "Xử lý" },
    { id: 3, name: "Chờ phí" },
    { id: 4, name: "Hoàn thành" },
  ];

  return (
    <div className="w-full">
      {/* Status Label */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-semibold text-neutral-textPrimary font-body">
          Tiến độ xử lý
        </span>
        <span
          className={`text-sm font-bold ${currentStatus.textColor} font-body`}
        >
          {currentStatus.percent}%
        </span>
      </div>

      {/* Progress Bar */}
      <div className="w-full bg-neutral-bgDefault rounded-full h-3 mb-4 overflow-hidden border border-neutral-divider">
        <div
          className={`h-full ${currentStatus.bgColor} rounded-full transition-all duration-500 ease-out relative overflow-hidden`}
          style={{ width: `${currentStatus.percent}%` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-30 animate-pulse-slow"></div>
        </div>
      </div>

      {/* Steps */}
      <div className="flex justify-between">
        {steps.map((step) => (
          <div
            key={step.id}
            className="flex flex-col items-center"
            style={{ width: `${100 / steps.length}%` }}
          >
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-normal ${
                step.id <= currentStatus.step
                  ? `${currentStatus.bgColor} text-white shadow-md-tqc`
                  : "bg-neutral-bgDefault text-neutral-textSecondary border border-neutral-divider"
              }`}
            >
              {step.id <= currentStatus.step ? (
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                step.id
              )}
            </div>
            <span
              className={`text-xs mt-2 text-center font-body ${
                step.id <= currentStatus.step
                  ? "text-neutral-textPrimary font-semibold"
                  : "text-neutral-textSecondary"
              }`}
            >
              {step.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
